// components/SidebarLayout.jsx
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { SlLocationPin } from "react-icons/sl";
import { FiLayers } from "react-icons/fi";
import { PiSignOutBold } from "react-icons/pi";
import { MdOutlinePersonOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { FaHeart } from "react-icons/fa";
import { navItems } from "../../../constants/headerMenu";



const SidebarLayout = () => {
  const { loginDetails } = useSelector((state) => state.counter);
  const name = loginDetails.name || null;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div >
      <div className="w-[260px] bg-[var(--primary-bg-color)] shadow-[0_0_10px_rgba(0,0,0,0.06)] border border-[#E4E7E9] rounded-xl py-4">
        {navItems.map(({ label, icon, to }, index) => (
          <NavLink
            key={index}
            to={to}
            onClick={(e) => {
              if (label === "Logout") {
                e.preventDefault();
                dispatch({ type: "RESET_STORE" });
                navigate("/");
              }
            }}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 hover:bg-gray-100 text-sm font-medium ${
                isActive ? "bg-[#02537F] text-white" : "text-[#5F6C72]"
              }`
            }
          >
            <span className="text-lg">{icon}</span>
            {label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default SidebarLayout;
